// extracted by mini-css-extract-plugin
export default {"success":"Status-module__success___oa3O8","alert":"Status-module__alert___IuioE","warning":"Status-module__warning___eEhhx","default":"Status-module__default___UUB8S"};